import "./frontend.scss";
import ReactDOM from "react-dom";
import UnitedStatesForm from "./components/UnitedStatesForm";
import InternationalForm from "./components/InternationalForm";

document.addEventListener("DOMContentLoaded", function () {
  const divToUpdate = document.querySelectorAll(".fx-form-update");

  divToUpdate.forEach((div) => {
    const data = JSON.parse(div.querySelector("pre").innerHTML);
    ReactDOM.render(<FxForm {...data} />, div);
    div.classList.remove("fx-form-update");
  });

  function FxForm({ usForm, locale }) {
    return (
      <div className="fx-form">
        {usForm ? (
          <UnitedStatesForm region={usForm} />
        ) : (
          <InternationalForm region={usForm} locale={locale || "GB"} />
        )}
      </div>
    );
  }
});
